import React from 'react';
import '../styles/Edcato_Hero.css';
import heroImage from '../../../../assets/solutions/edcato/edcato_hero.png';  // ✅ import image

const Edcato_Hero = () => {
  return (
    <div className="edcato-hero-container">
      <div className="edcato-hero-content">
        
        {/* Left side text */}
        <div className="edcato-hero-text">
          <h1>
            Efficient ERP and Learning Management System for Schools and Colleges
          </h1>

          <p>
            <strong>Edcato</strong> is a comprehensive digital platform designed to simplify and optimize 
            the administrative and academic processes of educational institutions. Combining a powerful 
            School ERP system with an intuitive Learning Management System, Edcato enables schools to 
            manage everything from admissions and attendance to financials and learning pathways in one 
            unified solution.
          </p>

          <ul className="hero-points">
            <li>
              Its cloud-based architecture ensures secure, real-time access for all stakeholders including 
              administrators, teachers, students, and parents, making communication and collaboration seamless.
            </li>
            <li>
              The platform supports personalized learning experiences, empowering educators to create adaptive 
              courses and track student progress efficiently.
            </li>
            <li>
              With mobile apps and responsive web design, users 
              can engage with the platform anytime and anywhere, enhancing accessibility and flexibility.
            </li>
            <li>
              Edcato also prioritizes data security and compliance, protecting sensitive information while 
              facilitating easy reporting and analytics for data-driven decision-making.
            </li>
          </ul>
        </div>

        {/* ✅ Right side image */}
        <div className="edcato-hero-image">
          <img src={heroImage} alt="Edcato Hero" />
        </div>

      </div>
    </div>
  );
};

export default Edcato_Hero;
